if (!customElements.get('tablist-component')) {
  customElements.define('tablist-component', class TabList extends HTMLElement {
    constructor() {
      super();

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick.bind(this)));
    }

    get tabs() {
      return this.querySelectorAll('[role="tab"][aria-controls]');
    }

    get hiddenClass() {
      return 'hidden';
    }

    handleTabClick(event) {
      const panelId = event.target.getAttribute('aria-controls');
      if (!panelId) return;

      const targetPanel = document.getElementById(panelId);
      if (!targetPanel) return;

      this.tabs.forEach((tab) => {
        if (event.target === tab) return;

        tab.removeAttribute('aria-selected');

        const tabPanelId = tab.getAttribute('aria-controls');
        if (!tabPanelId) return;

        const tabPanel = document.getElementById(tabPanelId);
        if (!tabPanel) return;

        tabPanel.classList.add(this.hiddenClass);
      });

      targetPanel.classList.remove(this.hiddenClass);
      event.target.setAttribute('aria-selected', 'true');

      const splideCarousel = targetPanel.querySelector('splide-carousel');
      if (!splideCarousel) return;
      if (splideCarousel.splideInstance) splideCarousel.splideInstance.refresh();
    }
  });
}